export default __webpack_public_path__ + "static/media/styles.f9c198d0.pcss";